import icHeroes from 'assets/svg/ic_marketplace_heroes.svg';
import icCosmetic from 'assets/svg/ic_marketplace_cosmetic.svg';
export let MarketPlaceTab;

(function (MarketPlaceTab) {
  MarketPlaceTab["HEROES"] = "heroes";
  MarketPlaceTab["COSMETICS"] = "cosmetics";
})(MarketPlaceTab || (MarketPlaceTab = {}));

export const listTab = [{
  name: 'Heroes',
  icon: icHeroes,
  key: MarketPlaceTab.HEROES
}, {
  name: 'Cosmetics',
  icon: icCosmetic,
  key: MarketPlaceTab.COSMETICS
}];